import React, {PropTypes } from 'react';

export class ErrorMessage extends React.Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string,
    marginTop: PropTypes.number
  };

  marginTop () {
    return this.props.marginTop
    ? {marginTop: this.props.marginTop + 'px'}
    : null;
  }

  render () {
    if (this.props.show && this.props.errorMessage) {
      return (
        <div
          className='error-message-without-border'
          style={this.marginTop()}>
          <span>{this.props.errorMessage}</span>
        </div>
      );
    }
    return null;
  }
}

export default ErrorMessage;



/** WEBPACK FOOTER **
 ** ./src/components/error-message/error-message.js
 **/